import {SnackbarMixin} from "@/app/mixins/SnackbarMixin";

const SnackbarPlugin = {
    install(Vue) {
        Vue.mixin(SnackbarMixin);
    }
};

export {SnackbarPlugin};
